// src/components/ProtectedRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  // ještě se načítá
  if (loading) {
    return <div style={{ padding: 24 }}>🔐 Ověřuji přihlášení…</div>;
  }

  // nepřihlášený
  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  // kontrola rolí
  if (roles?.length && !roles.includes(user.role)) {
    const fallbackByRole = {
      admin: "/admin/dashboard",
      rm: "/rm/dashboard",
      user: "/user/dashboard",
    };

    const fallback = fallbackByRole[user.role] || "/login";
    return <Navigate to={fallback} replace />;
  }

  // povoleno
  return children;
}